module.exports = __webpack_public_path__ + "img/nzavo-main.d9c77d69.webp";